import ReqClient from './request.class'

// 追踪计划列表分页查询
export async function queryTracePlanByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/queryTracePlanPagination',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 赠款消耗重算
export async function updateAmountByMonth(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/updateAmountByMonth',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询ios下架监控配置信息
export async function queryiOSTakeDownConfig() {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/queryGdReturnInfo',
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询ios下架监控配置信息
export async function saveiOSTakeDownConfig(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/submitGdReturnInfoGames',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 设置媒体计划id
export async function setMediaPlanId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/setMediaPlanId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放数据报表导入
export async function uploadPtomData(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/uploadptomdata',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 素材绑定计划关系批量导入
export async function imageBandingData(params) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/imageBandingData',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 快速联调
export async function quickDebugByMedia(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/callbackmedia',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改计划账号
export async function modifyPlanAccount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/modifyaccount',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 投放数据录入
export async function addPtomData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/addptomdata',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取录入的投放数据
export async function getPtomData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/getptomdata',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量添加投放计划白名单
export async function batchAddPlanWhiteList(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/batchAddPlanWhiteList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量删除投放计划白名单
export async function batchRemovePlanWhiteList(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/batchRemovePlanWhiteList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 追踪计划编辑
export async function updateTrackPlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/updateplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量修改投放计划落地页
export async function batchUpdatePlanPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/batchUpdatePlanPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量选中素材
export async function batchCheckMaterial(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/batchCheckMaterial',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 取消素材绑定
export async function cancelPlanImage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/cancelPlanImage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 取消落地页绑定
export async function cancelPlanPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/cancelPlanPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 追踪计划新建
export async function createTrackPlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/submitaddplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 删除一个常用游戏
export async function delPopularGame(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/delPopularGame',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增或修改一个常用游戏
export async function addPopularGame(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/addPopularGame',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取追踪计划详情
export async function getTrackPlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/queryPlanById',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建追踪计划结果导出
export async function createTrackPlanResultExport(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/downLoadResult',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量修改代投账号
export async function modifyPlanAgentAccount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/batchProxy',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建、重试华为分包
export async function createHuaweiExPkg(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/creat-extend-pkg',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 常用游戏查询
export async function queryPopulargameByPage(data) {
  const Req = new ReqClient({
    url: '/api/ptom/tracePlan/queryPopulargameByPage',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量清理代投账号
export async function cancelProxyAccountPlan(data) {
  const Req = new ReqClient({
    url: '/api/ptom/proxy-account/cancelProxyAccountPlanBatch',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询代投录入数据（按计划）
export async function queryProxyImportDataByPlanId(params) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/proxyImportData/queryByPlanId',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 导入代投录入数据（按计划）
export async function insertProxyImportDataByPlanId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/plandata/proxyImportData/insertBatch',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
